const initialState = {
  blogs: [],
  blog: null,
  total: 0,
  loading: false,
  error: null,
};

export const blogReducer = (state = initialState, action) => {
  switch (action.type) {

    case "BLOG_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_LIST_SUCCESS":
      return { ...state, loading: false, blogs: action.payload.data || [], total: action.payload.total || 0, error: null };
    case "BLOG_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "BLOG_ALL_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_ALL_LIST_SUCCESS":
      return { ...state, loading: false, blogs: action.payload.data || [], total: action.payload.total || 0, error: null };
    case "BLOG_ALL_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "BLOG_ADD_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_ADD_SUCCESS":
      return { ...state, loading: false, error: null };
    case "BLOG_ADD_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "BLOG_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_UPDATE_SUCCESS":
      return { ...state, loading: false, blog: action.payload.data || null, error: null };
    case "BLOG_UPDATE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "BLOG_STATUS_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_STATUS_SUCCESS":
      return { ...state, loading: false, error: null };
    case "BLOG_STATUS_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "BLOG_VIEW_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_VIEW_SUCCESS":
      return { ...state, loading: false, blog: action.payload.data || null, error: null };
    case "BLOG_VIEW_FAIL":
      return { ...state, loading: false, error: action.payload, blog: null };

    case "BLOG_REMOVE_REQUEST":
      return { ...state, loading: true, error: null };
    case "BLOG_REMOVE_SUCCESS":
      return { ...state, loading: false, error: null };
    case "BLOG_REMOVE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_BLOG_ERRORS":
      return { ...state, error: null };

    default:
      return state;
  }
};